import { useEffect, useState, useCallback } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  CustomCard,
  PageHeading,
  BootstrapTable,
  LastHeaderColumn,
  FirstHeaderColumn
} from "../common-styling";
import Filter from "../table-filter/filter";
import TableLoader from "../loader/table-loader";
import KeywordsTableRow from "./keywords-table-row";
import { showError } from "../../services/toast-service";
import CustomPagination from "../pagination/custom-pagination";
import { getAllKeywords } from "../../services/api-declaration";
import { useTranslation } from "react-i18next";

const KeywordsTable = () => {
  const { t } = useTranslation();
  const [keywords, setKeywords] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [paginateOpts, setPaginateOpt] = useState({});
  const [searchParams, setSearchParams] = useSearchParams();

  const fetchKeywords = async () => {
    try {
      setIsLoading(true);
      const params = {};
      for (const [key, value] of searchParams.entries()) {
        params[key] = value;
      }
      const response = await getAllKeywords(params);
      const data = response.data.data;
      setKeywords(data.rows);
      setPaginateOpt({
        totalPages: data.totalPages,
        hasPrevPage: data.hasPrevPage,
        hasNextPage: data.hasNextPage,
        totalDocs: data.totalDocs,
        rowsOnPage: data.rows.length
      });
    } catch (error) {
      console.log(error);
      showError(
        t("toastMessage.errorInGetting", { what: t("common.keywords") })
      );
    } finally {
      setIsLoading(false);
    }
  };
  const handleQueryParams = (property, value) => {
    searchParams.set(property, value);
    setSearchParams(searchParams);
  };
  const navigate = useNavigate();
  const handleModal = () => navigate("new");

  const keywordsCb = useCallback(
    fetchKeywords,
    // eslint-disable-next-line
    [searchParams]
  );
  useEffect(() => {
    keywordsCb();
  }, [keywordsCb]);

  return (
    <div>
      <PageHeading className="">{t("common.keywords")}</PageHeading>
      <div className="mt-3">
        <Filter
          pageName="name"
          placeholder={t("searchByNamePlaceholder")}
          btnText={t("common.createNew.title", {
            name: t("common.keyword").toLowerCase()
          })}
          handleModal={handleModal}
          shouldDisplayResourceType={false}
        />
      </div>
      <CustomCard className="mt-4 mb-3 p-3 rounded-0">
        <BootstrapTable responsive>
          <thead>
            <tr>
              <FirstHeaderColumn>{t("common.name")}</FirstHeaderColumn>
              <LastHeaderColumn empty />
            </tr>
          </thead>
          <tbody>
            {isLoading ? (
              <TableLoader colSpan={2} />
            ) : (
              <KeywordsTableRow
                keywords={keywords}
                fetchKeywords={fetchKeywords}
              />
            )}
          </tbody>
        </BootstrapTable>
      </CustomCard>
      <CustomPagination
        paginateOpts={paginateOpts}
        activeTab={Number(searchParams.get("pageIndex")) || 1}
        select={(val) => handleQueryParams("pageIndex", val)}
      />
    </div>
  );
};
export default KeywordsTable;
